module.exports = __webpack_public_path__ + "img/android.90e4e2f7.svg";